import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ChronosScanAiHero from "./sections/ChronosScanAiHero";
import CommunitySupportHub from "./sections/CommunitySupportHub";
import OurPartnersAndCertificates from "./sections/OurPartnersAndCertificates";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ChronosScanAiHero />
      <CommunitySupportHub />
      <OurPartnersAndCertificates />
      <Footer />
    </div>;
}